const product = {
  // Features - Optics
  p2_optics_title: '强大，藏在微小之中',
  p2_optics_sub: 'STRENGTH LIES IN THE SMALL.',
  p2_optics_badge1_zh: '超微型光机',
  p2_optics_badge2_zh: '高亮显示',
  p2_optics_badge3_zh: '户外清晰可见',
  p2_optics_body: '超清显示技术，藏进米粒大小的空间。NIMO 搭载 0.03CC 超微型光机，却能爆发出 1500nits 入眼亮度，即使在正午强烈的阳光下，画面依然清晰锐利，为你呈现每一个精彩细节。',

  // Features - Materials
  p2_mat_title: '屏幕就在镜片里，\n但你看不见它',
  p2_mat_sub: 'THE SCREEN IS INSIDE THE LENS\nBUT YOU CAN\'T SEE IT.',
  p2_mat_body: '这是光学技术的艺术。采用先进的双目体全息光波导技术，实现高达 98% 的惊人透光率。戴上它，世界依然通透真实，没有「屏幕」的隔阂。同时，独特的光路设计确保信息只为你一人所见，旁人无法窥探，全方位守护你的隐私安全。',
  p2_mat_b1_zh: '双目体全息光波导',
  p2_mat_b2_zh: '无泄漏隐私保护',
  p2_stat1_zh: '超高透光率',
  p2_stat1_desc: '双目体全息光波导，世界依然通透，画面只属于你。',
  p2_stat2_zh: '高清清晰度',
  p2_stat2_desc: '户外强光下清晰可见，细节表现锐利精准，视觉无妥协。',
  p2_stat3_zh: '旁人视角透出',
  p2_stat3_desc: '独特光路设计确保信息只为你所见，全方位隐私防护。',

  // Specs
  p2_specs_label: 'Full Specifications',
  p2_specs_title: '技术规格',
  p2_specs_sub: '每一项参数都来自真实工程数据，每一处细节都经过反复推敲与打磨。',
  p2_spec_cat1: '微型光机',
  p2_spec_cat2: '光波导',
  p2_spec_cat3: '材料结构',
  p2_spec_cat4: '无线连接',
  p2_spec_cat5: '生产力',
  p2_spec_cat6: '续航与配镜',
  p2_spec_l1_1: '光机体积', p2_spec_v1_1: '0.03cc',
  p2_spec_l1_2: '入眼亮度', p2_spec_v1_2: '1500 nits',
  p2_spec_l1_3: '分辨率', p2_spec_v1_3: '540 × 280',
  p2_spec_l2_1: '技术类型', p2_spec_v2_1: '体全息光波导',
  p2_spec_l2_2: '透光率', p2_spec_v2_2: '98%',
  p2_spec_l2_3: 'FOV', p2_spec_v2_3: '28°',
  p2_spec_l3_1: '镜框材质', p2_spec_v3_1: '碳纤维',
  p2_spec_l3_2: '镜腿材质', p2_spec_v3_2: 'β钛合金',
  p2_spec_l3_3: '整机重量', p2_spec_v3_3: '约29g',
  p2_spec_l4_1: '无线同步', p2_spec_v4_1: 'Dual-Sync',
  p2_spec_l4_2: '支持平台', p2_spec_v4_2: 'Android，iOS',
  p2_spec_l4_3: '无线协议', p2_spec_v4_3: '蓝牙 5.2',
  p2_spec_l5_1: '翻译延迟', p2_spec_v5_1: '< 1 秒',
  p2_spec_l5_2: '识别准确率', p2_spec_v5_2: '95%+',
  p2_spec_l5_3: '防护等级', p2_spec_v5_3: 'IP54',
  p2_spec_l6_1: '续航时间', p2_spec_v6_1: '24–48H 根据使用频次变化',
  p2_spec_l6_2: '充电时间', p2_spec_v6_2: '25 分钟满电',
  p2_spec_l6_3: '工作温度', p2_spec_v6_3: '-10°C 至 50°C',

  // Hero - top banner
  p2_hero_title: 'NIMO 智能眼镜',
  p2_hero_sub: '感知进化 · 全感交融',
  p2_hero_desc: '全新一代 NIMO 智能眼镜，双目体全息光波导显示融合云端AI大模型，1500nits亮度，长续航，超轻机身设计。',

  // Hero - slides
  p2_s1_title: '戴上它，\n看见新世界。',
  p2_s1_f1: '沉浸式数字体验',
  p2_s1_f2: '全场景 AI 赋能',
  p2_s1_desc: '无论是穿梭在繁忙的都市街道，还是沉浸在跨国会议的沟通中，NIMO 都能为你开启全新的视觉维度。导航指引、实时翻译、信息提示……所有数字信息与现实世界无缝融合，所见即所得，让你的每一次注视都充满力量。',
  p2_s2_title: '轻如羽翼，\n科技无形。',
  p2_s2_f1: '29g 超轻机身',
  p2_s2_f2: '全天候佩戴无感',
  p2_s2_desc: '以航空级钛合金为骨架，重新定义智能穿戴的重量边界。仅 29g 的全机身重量，配合精密调校的 5:5 前后配重，让眼镜如同你身体的延伸，从清晨到深夜，始终感觉不到负担。',
  p2_s3_title: '1500nits，\n清晰可见。',
  p2_s3_f1: '双目光波导',
  p2_s3_f2: '户外强光可见',
  p2_s3_desc: '搭载自主研发双目光波导显示系统，峰值亮度高达 1500nits，即便在强烈阳光直射下，画面依旧清晰锐利。云端AI大模型实时渲染，让每一帧都精准落在你的视线中央。',
  p2_s4_title: '思绪归为，\n心流自成。',
  p2_s4_f1: '接入各家AI大模型',
  p2_s4_f2: '云端低延迟实时分析',
  p2_s4_desc: '深度接入国内外主流AI大模型，通过云端超低延迟推理实现毫秒级智能响应。从多语种翻译到实时问答，从情境感知到个性化建议，NIMO 汇聚顶尖AI能力，让你的每一刻都拥有最强大脑加持。',

  // Hero - light section
  p2_light_title: '戴一整天，轻若无物',
  p2_light_sub: 'Wearing it all day feels like wearing nothing.',
  p2_light_body: '挑战工艺边界，只为给你超轻的佩戴体验。29g 的惊人重量，配合精心调教的 50:50前后黄金配重，让眼镜重心稳稳落在耳际，彻底释放鼻梁压力。即使从清晨戴到深夜，你也几乎感觉不到它的存在。',
  p2_light_s1: '超轻 AI 智能眼镜',
  p2_light_s2: '鼻梁零负担',
  p2_light_s3: '5:5 黄金配重',

  // Hero - vision section
  p2_vision_title: '看见更广阔的世界。',
  p2_vision_sub: 'See a world beyond what the eye can reach.',
  p2_vision_body: '双目光波导显示，1500nits 超高亮度，无论在强光户外还是昏暗室内，画面始终清晰如初。云端多模型实时处理，导航、翻译、提醒同步呈现，所有信息在你眼前，触手可及。',
  p2_vision_s1: '双目全彩波导',
  p2_vision_s2: '1500nits 亮度',
  p2_vision_s3: '云端 AI 处理',

  // CTA
  p2_cta_label: 'NIMO 智能眼镜 2',
  p2_cta_title: '提前体验',
  p2_cta_title2: '感知进化的下一步',
  p2_cta_color_label: '配色',
  p2_cta_color1: '星夜黑',
  p2_cta_color2: '月光白',
  p2_cta_desc: '智能眼镜 2 现正接受预约体验申请，率先加入 NIMO 早鸟计划，获得首批产品优先购买权及专属礼遇。',
  p2_cta_btn1: '立即购买 →',
  p2_cta_btn2: '返回首页',
  p2_cta_disclaimer: '产品规格及外观设计可能因量产版本而有所调整 · 以官方正式发布信息为准',
};

export default product;
